module.exports = __webpack_public_path__ + "static/media/GREEN.45ad26a9.png";